var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 56,
    viewBox: "0 0 74 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86328 12.7998C7.86328 10.9998 8.14078 9.7998 9.71328 9.9998C18.5008 12.0001 25.9008 10.4397 33.3008 7.7998C42.5508 4.49987 53.6508 3.9998 64.0108 5.9998C65.7683 6.2998 65.8608 7.5998 65.8608 9.4998V44.1998C65.8608 46.0998 64.5658 46.1998 62.9008 45.8998C52.2633 42.5001 44.8633 43.5 33.3008 47.0998C24.4208 49.0998 17.0208 49.9998 10.6383 47.7998C8.78828 47.1998 7.86328 46.7998 7.86328 44.7998V12.7998Z",
    fill: "white",
    stroke: "#001860",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06641 11C12.0264 11.6 14.8939 11.8 17.5764 11.2C16.8364 15.2 14.3389 18 9.06641 18.5V11Z",
    fill: "#001860"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1641 6C60.3091 6 62.8991 6.4 65.1191 7V16.4C61.7891 15.7 59.1991 13.8 58.2741 10.7L57.1641 6Z",
    fill: "#001860"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0653 40.2002C12.9503 40.6002 15.9103 43.1002 17.0203 47.9002C14.3378 48.0002 11.9328 47.5002 9.8053 46.7002C9.1578 46.3002 8.9728 44.7002 9.0653 40.2002Z",
    fill: "#001860"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8867 43.9998C58.2742 40.3998 61.0492 37.8998 65.4892 37.2998V43.3998C65.4892 44.9998 64.2867 45.7998 62.8067 45.4998L56.8867 43.9998Z",
    fill: "#001860"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 36C40.1944 36 44 31.9706 44 27C44 22.0294 40.1944 18 35.5 18C30.8056 18 27 22.0294 27 27C27 31.9706 30.8056 36 35.5 36Z",
    fill: "#001860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash-icon.9dd8033d.svg";
export { ForwardRef as ReactComponent };